import clsx from 'clsx';
import { Button } from 'components/button';
import CustomSelect from 'components/fields/Select';
import React from 'react';
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdFirstPage,
  MdLastPage,
} from 'react-icons/md';

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalName?: string;

  itemsPerPage: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
  isBottomIndicators?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  totalPages,
  onPageChange,
  itemsPerPage,
  totalName = 'items',
  onItemsPerPageChange,
  isBottomIndicators,
}) => {
  return (
    <div
      className={clsx(
        'mt-auto flex flex-col justify-start gap-2 pt-5 lg:flex-row lg:items-center',
        isBottomIndicators && '!flex-col !items-center'
      )}
    >
      <div className="flex flex-col gap-2 md:flex-row md:items-center">
        <Button disabled={currentPage <= 0} onClick={() => onPageChange(0)}>
          <MdFirstPage /> First
        </Button>
        <Button
          disabled={currentPage <= 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <MdArrowBackIosNew /> Previous
        </Button>
        <Button
          disabled={currentPage + 1 >= (totalPages ?? 1)}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
          <MdArrowForwardIos />
        </Button>

        <Button
          disabled={currentPage + 1 >= (totalPages ?? 1)}
          onClick={() => onPageChange(totalPages > 1 ? totalPages - 1 : 0)}
        >
          Last
          <MdLastPage />
        </Button>
        <CustomSelect
          value={itemsPerPage.toString()}
          onChange={val => onItemsPerPageChange(Number(val))}
          options={[
            {
              label: '10',
              value: '10',
              className: 'text-black dark:text-white',
            },
            {
              label: '20',
              value: '20',
              className: 'text-black dark:text-white',
            },
            {
              label: '30',
              value: '30',
              className: 'text-black dark:text-white',
            },
            {
              label: '40',
              value: '40',
              className: 'text-black dark:text-white',
            },
            {
              label: '50',
              value: '50',
              className: 'text-black dark:text-white',
            },
          ]}
        />
      </div>
      <div
        className={clsx(
          'flex flex-col items-center gap-4 text-gray-700 dark:text-gray-200 lg:ml-auto md:flex-row',
          isBottomIndicators && '!ml-0'
        )}
      >
        <div>Current page: {Math.max(currentPage + 1, 1)}</div>
        <div>
          {totalName}: {totalItems ?? 0}
        </div>
        <div>Total pages: {Math.max(totalPages ?? 1, 1)}</div>
      </div>
    </div>
  );
};

export default Pagination;
